// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_20Y","cls2":"FilterPanel-cls2_sO5 FilterPanel-cls1_20Y","mobileLayout":"FilterPanel-mobileLayout_RPy"};